import React from 'react';
import './Service.css';

function Service(props) {
	return (
		<div className="c-service">
			{props.serviceName}
		</div>
	)
}

export default Service;


// WEBPACK FOOTER //
// ./src/components/Service.js